import Container from "./container";
import UrbanLogo from "../../assets/images/urban/urban-logo-02.png";
import { CiLocationOn } from "react-icons/ci";
import { BsTelephone } from "react-icons/bs";
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { SlSocialFacebook } from "react-icons/sl";
import { FaInstagram } from "react-icons/fa6";
import { RiTelegramLine } from "react-icons/ri";
const Footer = () => {
  return (
    <footer id="footer" className="py-10 md:py-14 text-white bg-black text-sm">
      <Container className="grid md:grid-cols-6 gap-10 lg:grid-cols-11 lg:gap-5">
        <div className="col-span-3 space-y-5">
          <div className="max-w-[200px]">
            <img
              src={UrbanLogo}
              alt="urban footer logo "
              className="w-full h-full object-cover"
            />
          </div>
          <p>
            URBAN Furniture Group focuses to supply Modernized and Functional
            Quality products with great service.
          </p>
        </div>
        <div className="space-y-5 col-span-3 ">
          <h6 className="text-2xl font-bold uppercase">INFORMATIONS</h6>
          <ul className="space-y-3">
            <li className="flex  gap-2">
              <p>
                <CiLocationOn size={25} />
              </p>
              <p>
                No. 2967 (A), Sittaung Street, Industry Zone 2, South Dagon,
                Yangon, Myanmar
              </p>
            </li>
            <li className="flex gap-2">
              <p>
                <MdOutlinePhone size={25} />
              </p>
              <p>+959 42388 0944</p>
            </li>
            <li className="flex gap-2 ">
              <p>
                <MdOutlineMail size={25} />
              </p>
              <p>info.urbanfurnituregroup@gmail.com</p>
            </li>
          </ul>
        </div>
        <div className="space-y-5 col-span-3">
          <h6 className="text-2xl font-bold uppercase">Useful Information</h6>
          <ul className="space-y-3">
            <li>
              <a href="#">About Us </a>
            </li>
            <li>
              <a href="#">Services </a>
            </li>
            <li>
              <a href="#">Shop </a>
            </li>
            <li>
              <a href="#">Projects </a>
            </li>
            <li>
              <a href="#">Contact Us</a>
            </li>
          </ul>
        </div>
        <div className=" space-y-5 col-span-3 lg:col-span-2">
          <h6 className="text-2xl font-bold uppercase">Follow Us</h6>
          <ul className="flex items- gap-5">
            <li>
              <a
                href="https://www.facebook.com/FIT.baemyanmar?mibextid=wwXIfr&mibextid=wwXIfr"
                target="_blank"
              >
                <SlSocialFacebook size={30} />
              </a>
            </li>
            <li>
              <a href="#">
                <FaInstagram size={30} />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/urban_furniture_group/profilecard/?igsh=MTFiNWNzYzVlcmM5MQ=="
                target="_blank"
              >
                <RiTelegramLine size={30} />
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
